import React from 'react';
import { useTranslation } from 'react-i18next';

import { AgentCard, AgentCardProps } from './AgentCard';
import { AgentCardSkeleton } from './AgentCardSkeleton';

export interface AgentCatalogGridProps {
    agents: AgentCardProps['agent'][];
    isLoading: boolean;
    onChat: (id: string) => void;
    onSettings: (id: string) => void;
    onShare: (id: string) => void;
    onDelete: (id: string) => void;
}

export const AgentCatalogGrid: React.FC<AgentCatalogGridProps> = ({
    agents,
    isLoading,
    onChat,
    onSettings,
    onShare,
    onDelete,
}) => {
    const { t } = useTranslation();

    if (isLoading) {
        return (
            <div className="grid grid-cols-[repeat(auto-fill,minmax(400px,1fr))] max-xs:grid-cols-1 gap-6">
                {Array.from({ length: 6 }).map((_, index) => (
                    <AgentCardSkeleton key={index} />
                ))}
            </div>
        );
    }

    if (!agents.length) {
        return (
            <div className="py-20 text-center">
                <div className="text-muted-foreground text-lg mb-2">{t('agent.catalog.emptyState.title')}</div>
                <div className="text-sm text-muted-foreground">{t('agent.catalog.emptyState.description')}</div>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(400px,1fr))] max-xs:grid-cols-1 gap-6">
            {agents.map(agent => (
                <AgentCard
                    key={agent.id}
                    agent={agent}
                    onChat={onChat}
                    onSettings={onSettings}
                    onShare={onShare}
                    onDelete={onDelete}
                />
            ))}
        </div>
    );
};
